import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemove = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 9.5,
			fill: "#12326E",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.35358 5.64648L14.3536 14.6465",
			stroke: "#E73088",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.64642 14.6465L14.6464 5.64648",
			stroke: "#E73088",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgRemove;
